import { useEffect, useState } from 'react'
import styles from './styles.module.sass'

const SearchProducts = (props) => {
    const {
        setSearchWord
    } = props

    const timeToSend = 1000
    const longText = 3

    const [ searchText, setSearchText ] = useState('')

    const handleSubmit = (event) => {
        event.preventDefault()
        if(searchText.length >= longText){
            setSearchWord(searchText)
        }
    }

    const handleChange = (e) => {
        const { value, name } = e.target

        if(name === 'searchProducts'){
            setSearchText(value)
        }
  }


    useEffect(() => {

        const handleTypingStopped = () => {
            if (searchText.length >= longText) {
                setSearchWord(searchText)
            }
        };

        // Configuramos un temporizador para ejecutar después de 3 segundos
        const timeoutId = setTimeout(handleTypingStopped, timeToSend);

        // Limpiamos el temporizador cada vez que se cambia el searchText
        return () => clearTimeout(timeoutId);
    }, [searchText, setSearchWord]);
    
    return(
        <form onSubmit={handleSubmit} className={styles?.contSearch}>
            <input
                className={styles?.search}
                type="search"
                name="searchProducts"
                onChange={handleChange}
                defaultValue={searchText}
                placeholder="Busca por producto, marca, departamento , código y más..." 
            />
        </form>
    )
}

export default SearchProducts